import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RootStoreState } from '@app/root-store';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { InboxSettingsService } from '@app/shared/services/settings/inbox-settings/inbox-settings.service';
import { Store } from '@ngrx/store';
import { Observable, Subscription, fromEvent } from 'rxjs';
import { AddSubfolderComponent } from '../../../dialogs/add-subfolder/add-subfolder.component';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { FilePreviewSetupComponent } from '../../mini-form-creation/set-up-form-creation/file-preview-setup/file-preview-setup.component';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'inbox-attachment-list',
  templateUrl: './inbox-attachment-list.component.html',
  styleUrls: ['./inbox-attachment-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InboxAttachmentListComponent implements OnInit, OnDestroy {
  @ViewChildren(FilePreviewSetupComponent) fileExtensionComponentchild: QueryList<FilePreviewSetupComponent>;

  loadOnce = true;
  searchText = '';
  loaderItems = [{ id: 1 }, { id: 2 }, { id: 3 }];
  is_file_loading = true;
  loginStateObject;
  currentuserId;
  subscription: Subscription = new Subscription();
  @Input() inboxFiles = [];
  @Input() enable_task = false;

  hideAttachmentAvailableSection = false;
  resizeObservable$: Observable<Event>;
  screenWidth: number;
  filteredFileItems = [];
  constructor(
    private toastr: ToastrService,
    private _inboxService: InboxSettingsService,
    private cd: ChangeDetectorRef,
    private dialog: MatDialog,
    private store$: Store<RootStoreState.State>,
    private loginService: LoginStoreEffects
  ) {}
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  deleteAttachment(index, id, display_file_name) {
    const dialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: { title: 'Delete File', materialIcon: 'delete', text: `Are you sure you want to delete ${display_file_name}?`, proceedTitle: 'Delete' },
    });

    this.subscription.add(
      dialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          this.subscription.add(
            this._inboxService.deleteInboxAttachments([id], this.currentuserId).subscribe(
              (res) => {
                const fileIndex = this.inboxFiles.findIndex((f) => f.id === id);
                if (fileIndex) {
                  this.inboxFiles.splice(fileIndex, 1);
                }
                this.toastr.success(`${display_file_name} deleted`);
                this.cd.detectChanges();
              },
              (error) => {}
            )
          );
        }
      })
    );
  }

  renameFolder(folder, index) {
    let i = this.inboxFiles.findIndex((x) => x.id == folder.id);
    let file_name_without_extesion =
      folder.file_name.split('.').slice(0, -1).length == 0 ? folder.file_name : folder.file_name.split('.').slice(0, -1).join('.');
    const dialogRef = this.dialog.open(AddSubfolderComponent, {
      width: '400px',
      maxWidth: this.screenWidth < 480 ? '90vw' : '80vw',
      data: {
        title: 'Rename Attachment',
        buttonName: 'Rename',
        currentFolderName: file_name_without_extesion,
      },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((Resultdata) => {
        if (Resultdata && Resultdata.confirmation) {
          const extension =
            this.inboxFiles[i].file_name.substring(this.inboxFiles[i].file_name.lastIndexOf('.') + 1, this.inboxFiles[i].file_name.length) ||
            this.inboxFiles[i].file_name;
          const data = {
            custom_folder_name: Resultdata.subfolderName + '.' + extension,
            id: this.inboxFiles[i]['id'],
          };
          this.subscription.add(
            this._inboxService.updateInboxAttachmentFileName(data).subscribe((res) => {
              this.inboxFiles[i].file_name = Resultdata.subfolderName;
              this.cd.detectChanges();
            })
          );
        }
      })
    );
  }

  onInputChange(searchValue: string) {
    this.searchText = searchValue;
    this.inboxFiles.forEach((element, index) => {
      element.selected = false;
    });
    this.cd.detectChanges();
  }

  getInboxData(userId: number) {
    this.subscription.add(
      this._inboxService.getInboxData(userId).subscribe(
        (result: any) => {
          // set file list
          this.inboxFiles = [];
          if (result?.data) {
            result?.data.forEach((element) => {
              this.inboxFiles.push({
                ...element,
                status: 'Done',
                selected: false,
                showButton: false,
              });
            });
          }

          if (this.inboxFiles.length == 0) {
            this.hideAttachmentAvailableSection = true;
          }
          this.is_file_loading = false;
          this.cd.detectChanges();
          setTimeout(() => {
            // this will make the execution after the above boolean has changed
            this.fileExtensionComponentchild.forEach((FileExtensionComponent, index) => {
              FileExtensionComponent.StartPreviewImage();
            });
          }, 0);
        },
        (error: any) => {}
      )
    );
  }

  ngOnInit(): void {
    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        this.loginStateObject = { ...state.data };

        if (state?.data) {
          this.currentuserId = state.data.id;
          if (this.loadOnce) {
            this.getInboxData(this.currentuserId);
            this.loadOnce = false;
          }
        }
      })
    );
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );
  }

  get filteredItems() {
    if (this.searchText && this.searchText.length > 0) {
      this.filteredFileItems = this.inboxFiles.filter((x) => x.file_name?.toLowerCase().includes(this.searchText.toLowerCase()));
      return this.filteredFileItems;
    }
    this.filteredFileItems = this.inboxFiles;
    return this.filteredFileItems;
  }
}
